/**
 * @file
 * Content toggle functionality.
 */

/* eslint-disable-next-line import/no-extraneous-dependencies */
import _ from "lodash";

(($, { behaviors }) => {
  /**
   * Toggles the content of the targeted content toggle.
   *
   * @param {jQuery} $targetedToggle
   *   The targeted content toggle DOM element.
   */
  function toggleContent($targetedToggle) {
    const $contentToggleContent = $targetedToggle.find(
      ".js-content-toggle__content"
    );
    const $contentToggleButton = $targetedToggle.find(
      ".js-content-toggle__button"
    );
    const $contentToggleButtonText = $targetedToggle.find(
      ".js-content-toggle__button-text"
    );

    $contentToggleButton.toggleClass("is-expanded");
    $contentToggleContent.toggleClass("is-expanded").slideToggle(225);

    const contentToggleContentIsExpanded =
      $contentToggleContent.hasClass("is-expanded");

    if (contentToggleContentIsExpanded) {
      $contentToggleButton.attr("aria-expanded", "true");
      $contentToggleButtonText.text(() => Drupal.t("Show less"));
    } else {
      $contentToggleButton.attr("aria-expanded", "false");
      $contentToggleButtonText.text(() => Drupal.t("Show more"));
    }
  }

  /**
   * Attaches behaviors for content toggle.
   *
   * @type {Drupal~behavior}
   *
   * @prop {Drupal~behaviorAttach} attach
   *   Attaches the content toggle behavior.
   */
  behaviors.contentToggle = {
    attach(context) {
      const $contentToggleButton = $(".js-content-toggle__button", context);
      $contentToggleButton.on(
        "click",
        _.debounce((event) => {
          const $targetedButton = $(event.currentTarget);
          const $targetedToggle = $targetedButton.closest(".js-content-toggle");

          toggleContent($targetedToggle);
        }, 150)
      );
    }
  };
})(jQuery, Drupal);
